export * from "./MyStaysConfigurationDTO";
